import { createFileRoute } from '@tanstack/react-router';
import { Users } from '../../organisms/Users';

export const Route = createFileRoute('/_authenticated/users')({
  component: Users,
});
